import { AGRNT_AUTH_CODE } from '@/pages/agent/js/enum'

/** *
 * * 特殊行业权限对应映射关系
 * * - 将部分行业场景下的权限code篡改成原有的基础权限code，以兼容已有的旧页面代码中的功能权限判断
 * */
export default {
  // * 代理业务模式： 0：私域带货；1：健康讲座，2：生鲜零售
  2: {
    /** 客户管理 */
    [AGRNT_AUTH_CODE.FRESH_CUSTOMER_MANAGEMENT]:
      AGRNT_AUTH_CODE.CUSTOMER_MANAGEMENT,
    /** 会员管理 */
    [AGRNT_AUTH_CODE.FRESH_CLUB]: AGRNT_AUTH_CODE.MEMBERS_VIEW,
    /** 会员升降级 */
    [AGRNT_AUTH_CODE.FRESH_MENBER_PROMOTION_AND_DEMOTION]:
      AGRNT_AUTH_CODE.MEMBER_PROMOTION_AND_DEMOTION,
    /** 会员移除 */
    [AGRNT_AUTH_CODE.FRESH_MEMBER_DELETE]: AGRNT_AUTH_CODE.MEMBER_DELETE,
    /** 消耗积分 */
    [AGRNT_AUTH_CODE.FRESH_CONSUME_POINTS]: AGRNT_AUTH_CODE.CONSUME_POINTS,
    /** 发送积分 */
    [AGRNT_AUTH_CODE.FRESH_SEND_POINTS]: AGRNT_AUTH_CODE.SEND_POINTS,
    /** 拉黑 */
    [AGRNT_AUTH_CODE.FRESH_DEFRIEND]: AGRNT_AUTH_CODE.DEFRIEND,
    /** 禁言 */
    [AGRNT_AUTH_CODE.FRESH_FORBIDDEN_SPEECH]: AGRNT_AUTH_CODE.FORBIDDEN_SPEECH,
    /** 解/换绑 */
    [AGRNT_AUTH_CODE.FRESH_UNBIND_OR_REPLACE_BINDING]:
      AGRNT_AUTH_CODE.UNBIND_OR_REPLACE_BINDING,
    /** 代客下单 */
    [AGRNT_AUTH_CODE.FRESH_AGENT_TAKE_ORDER]: AGRNT_AUTH_CODE.AGENT_TAKE_ORDER,
    /** 会员审核 */
    [AGRNT_AUTH_CODE.FRESH_MEMBER_AUDIT]: AGRNT_AUTH_CODE.MEMBER_AUDIT,
    /** 推广直播 */
    [AGRNT_AUTH_CODE.FRESH_LIVE]: AGRNT_AUTH_CODE.LIVE_PROMOTION,
    /** 推广商品 */
    [AGRNT_AUTH_CODE.FRESH_PICKS]: AGRNT_AUTH_CODE.PRODUCT_PROMOTION,
    /** 推广团购 - 社群接龙 */
    [AGRNT_AUTH_CODE.FRESH_GROUP]: AGRNT_AUTH_CODE.SOCIAL_COMMUNITY_FISSION,
    /** 订单统计 */
    [AGRNT_AUTH_CODE.FRESH_ORDER_STATISTICS]: AGRNT_AUTH_CODE.ORDER_STATISTICS,
    /** 商品统计 */
    [AGRNT_AUTH_CODE.FRESH_PRODUCT_STATISTICS]:
      AGRNT_AUTH_CODE.PRODUCT_STATISTICS,
    /** 优惠券统计 */
    [AGRNT_AUTH_CODE.FRESH_COUPON_STATISTICS]:
      AGRNT_AUTH_CODE.COUPON_STATISTICS,
    /** 售后管理 */
    [AGRNT_AUTH_CODE.FRESH_CARE]: AGRNT_AUTH_CODE.AFTER_SALES_PROCESSING,
    /** 交易投诉 */
    [AGRNT_AUTH_CODE.FRESH_TRADING_COMPLAINTS]:
      AGRNT_AUTH_CODE.TRADING_COMPLAINTS,
    /** 商品经营 */
    [AGRNT_AUTH_CODE.FRESH_OPERATIONS]: AGRNT_AUTH_CODE.COMMODITY_MANAGEMENT,
    /** 发货单 - 在途配送 */
    [AGRNT_AUTH_CODE.FRESH_DELIVERY_NOTE]: AGRNT_AUTH_CODE.IN_TRANSIT_DELIVERY,
    /** 发货单 - 门店报表 */
    [AGRNT_AUTH_CODE.FRESH_STORE_DELIVERY_NOTE]:
      AGRNT_AUTH_CODE.TRANSIT_DELIVERY,
    /** 提货单 */
    [AGRNT_AUTH_CODE.FRESH_PICKUP_ORDER]: AGRNT_AUTH_CODE.BILL_OF_LADING,
    /** 自助核销 */
    [AGRNT_AUTH_CODE.FRESH_SELF_VERIFICATION]:
      AGRNT_AUTH_CODE.SELF_VERIFICATION_QRCODE,
    /** 核销记录 */
    [AGRNT_AUTH_CODE.FRESH_VERIFICATION_RECORD]:
      AGRNT_AUTH_CODE.VERIFICATION_RECORD,
    /** 门店报表 */
    [AGRNT_AUTH_CODE.FRESH_STORE_REPORT]: AGRNT_AUTH_CODE.STORE_REPORT,
    /** 客户列表 */
    [AGRNT_AUTH_CODE.FRESH_CUSTOMER_LIST]: AGRNT_AUTH_CODE.CUSTOMER_LIST,
    /** 订单统计(门店) */
    [AGRNT_AUTH_CODE.FRESH_STORE_ORDER_STATISTICS]:
      AGRNT_AUTH_CODE.STORE_ORDER_STATISTICS,
    /** 商品统计(门店) */
    [AGRNT_AUTH_CODE.FRESH_STORE_PRODUCT_STATISTICS]:
      AGRNT_AUTH_CODE.STORE_PRODUCT_STATISTICS,
    /** 优惠券统计(门店) */
    [AGRNT_AUTH_CODE.FRESH_STORE_COUPON_STATISTICS]:
      AGRNT_AUTH_CODE.STORE_COUPON_STATISTICS,
    /** 分佣明细 */
    [AGRNT_AUTH_CODE.FRESH_COMMISSION_DETAILS]:
      AGRNT_AUTH_CODE.COMMISSION_DETAILS,
    /** 核销记录(门店) */
    [AGRNT_AUTH_CODE.FRESH_VERIFICATION_RECORD_AGENT]:
      AGRNT_AUTH_CODE.VERIFICATION_RECORD_AGENT,
    /** 核销按钮 */
    [AGRNT_AUTH_CODE.FRESH_VERIFICATION_BUTTON]:
      AGRNT_AUTH_CODE.VERIFICATION_BUTTON,
    /** 团队业绩 */
    [AGRNT_AUTH_CODE.FRESH_TEAM_PERFORMANCE]: AGRNT_AUTH_CODE.TEAM_PERFORMANCE,
    /** 消费榜 */
    [AGRNT_AUTH_CODE.FRESH_CONSUMPTION_RANKING]:
      AGRNT_AUTH_CODE.CONSUMPTION_RANK,
    /** 支付有礼 */
    [AGRNT_AUTH_CODE.FRESH_PAYMENT_BONUS]: AGRNT_AUTH_CODE.PAY_WITH_GIFTS,
    /** 集卡奖励 */
    [AGRNT_AUTH_CODE.FRESH_STAMP_REWARDS]:
      AGRNT_AUTH_CODE.COLLECTING_CARDS_FOR_REWARDS,
    /** 社群红包 */
    [AGRNT_AUTH_CODE.FRESH_COMMUNITY_REDPACKET]:
      AGRNT_AUTH_CODE.COMMUNITY_RED_ENVELOPE,
    /** 经营报表 */
    [AGRNT_AUTH_CODE.FRESH_OPERATION_REPORT]: AGRNT_AUTH_CODE.BUSINESS_REPORT,
    /** 门店报表 */
    [AGRNT_AUTH_CODE.FRESH_OTHER_STORE_REPORT]: AGRNT_AUTH_CODE.STORE_REPORT,
    /** 我的团队 **/
    // [AGRNT_AUTH_CODE.FRESH_TEAM_MANAGEMENT]: AGRNT_AUTH_CODE.TEAM_PERFORMANCE,
  },
}
